import React, {useState} from 'react';
import {useTranslation} from 'react-i18next';
import {ButtonBase} from '../elements';
import {Coupons} from './Coupons';
import {Steps} from '../Steps/Steps';
import 'simplebar/dist/simplebar.min.css';
import '../../simplebar.css'
import {DefaultStepSettings} from "../App/DefaultStepSettings";
import {ReactComponent as CloseIcon} from '../coupons/Lists/assets/close.svg';
import { useDispatch, useSelector } from 'react-redux';
import { CHANGE_RIGHT_PANEL_TAB, MOBILE_MODAL_COUPON } from '../../store/spirs/actions';
import {Tabs} from "../tabs/Tabs";
import clsx from "clsx";
import { rightPanelTabType } from '../../store/spirs/reducers/rightPanelReducer';
import { StoreType } from '../../store/spirs/types';

export const CouponsPanel: React.FC = () => {
    const dispatch = useDispatch();
    const tab = useSelector((state: StoreType) => state.spirs.rightPanelTab)
    const setTabValue = (tab: rightPanelTabType)=> {
        dispatch(CHANGE_RIGHT_PANEL_TAB(tab));
    }
    React.useEffect(() => {
        return () => {
            dispatch(CHANGE_RIGHT_PANEL_TAB('coupon'));
        }
    }, [])

    const {t} = useTranslation();


    return (
        <div className="relative">
            <div className="grid grid-cols-[repeat(4,1fr)_50px] items-center">
                <div className={clsx("row-start-2 row-end-3 col-start-1 col-end-6",
                    "tablet:row-start-1 tablet:row-end-2 tablet:col-start-1 tablet:col-end-6")}
                >
                    <DefaultStepSettings/>
                </div>
                <div className={clsx("border border-[#121518]",
                    "row-start-1 row-end-2 col-start-1 col-end-5",
                    "tablet:row-start-2 tablet:row-end-3 tablet:col-start-1 tablet:col-end-6")}
                >
                    <Tabs
                        value={tab}
                        tabs={[{value: 'coupon', label: t('sideBar.tabs.coupon')}, {value: 'steps', label: t('sideBar.tabs.steps')}]}
                        onChange={setTabValue}
                    />

                </div>
                <div className="flex justify-center row-start-1 row-end-2 col-start-5 col-end-6 tablet:hidden">
                    <BackButtonForMobile/>
                </div>
                <div className="row-start-3 row-end-4 col-start-1 col-end-6 h-full overflow-hidden flex flex-col">
                    {tab === 'coupon' && <Coupons/>}
                    {tab === 'steps' && <Steps/>}
                </div>
            </div>

        </div>
    );
};

const BackButtonForMobile: React.FC = () => {
    const dispatch = useDispatch();
    const closeModal = () => dispatch(MOBILE_MODAL_COUPON(false));
    return (<ButtonBase onClick={closeModal} className="rounded-full">
        <div className="flex justify-center items-center min-w-[32px] min-h-[32px] bg-[#272D33] rounded-full text-white">
            <CloseIcon className="scale-75"/>
        </div>
    </ButtonBase>)
};
